import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import {
  ForemanProfile,
  Calender,
  PaymentRequests,
  PaymentHistory,
  AboutUs,
  CompanyRequests,
  RequestDetails,
  AddAddress,
  EditAddress,
  EditRequestExtraItems,
  EditRequestItems,
  Chats,
  SignAgreement,
  EditProfile,
  HowAllowLocation,
  MyRequests,
} from "../pages";

function Routes(props) {
  return (
    <Switch>
      <Route exact path="/salesman" component={ForemanProfile} />
      <Route exact path="/salesman/edit-profile" component={EditProfile} />
      <Route path="/salesman/calender" component={Calender} />
      <Route
        exact
        path="/salesman/salesman-requests"
        component={CompanyRequests}
      />
      <Route exact path="/salesman/my-requests" component={MyRequests} />
      <Route
        exact
        path="/salesman/salesman-requests/:requestId"
        component={RequestDetails}
      />
      <Route
        exact
        path="/salesman/salesman-requests/add-address/:requestId"
        component={AddAddress}
      />
      <Route
        exact
        path="/salesman/salesman-requests/edit-address/:requestId/:addressId"
        component={EditAddress}
      />
      <Route
        exact
        path="/salesman/salesman-requests/edit-items/:requestId"
        component={EditRequestItems}
      />
      <Route
        exact
        path="/salesman/salesman-requests/edit-extra-items/:requestId"
        component={EditRequestExtraItems}
      />
      <Route path="/foreman/chats" component={Chats} />
      <Route path="/salesman/about-us" component={AboutUs} />
      <Route path="/foreman/how-allow-location" component={HowAllowLocation} />

      <Route
        path="/salesman/salesman-requests/sign-agreement/:requestId"
        component={SignAgreement}
      />
    </Switch>
  );
}

export default Routes;
